import urlSimplify from './simplify';

type T = (given: string | URL, expected: string | URL) => boolean;

const f: T = (given, expected) => urlSimplify(given) === urlSimplify(expected);

export default f;
